import { Loading } from "@components/LoadingIndicator";
import { DefaultPageLayout } from "@components/layout/DefaultPageLayout";
import { PageSection } from "@components/layout/PageSection";

import { spacing } from "@every.org/common/src/display/spacing";

export const LoadingPage = () => (
  <DefaultPageLayout disableDonateModal>
    <PageSection css={{ padding: spacing.xl }}>
      <Loading />
    </PageSection>
  </DefaultPageLayout>
);
